// removed by extract-text-webpack-plugin
module.exports = {"loading":"_2UCzNbuKOoRGWJVsvZV5O4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/loading/style.css
// module id = 692
// module chunks = 0